module.exports = __webpack_public_path__ + "img/1_008.b78305a1.jpg";